import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatiIdentificativiFieldValidators } from './validators/dati-identificativi.field-validators';
import { DatiIdentificativiWarningsService } from './warnings/dati-identificativi.warnings';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [DatiIdentificativiFieldValidators, DatiIdentificativiWarningsService],
})
export class DatiIdentificativiFormModule {}
